export default "/images/vendor/flag-icon-css/flags/1x1/cx.svg?3760646934de106799599ab6c22127a9";